import React, { JSX } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { TaxationInterface } from "../../../interfaces/ProductInterface";

interface VatOptionSelection {
  onChange: (val: TaxationInterface) => void;
  vatPercentageOptions: { id: number; description: string }[];
  value?: TaxationInterface;
  sx: { [key: string]: string };
  dataTestmation?: string;
  label?: string;
  placeholder?: string;
}

export default function VatOptionSelection({
  vatPercentageOptions,
  onChange,
  value,
  sx,
  dataTestmation,
  label = "Vat Mapping",
  placeholder = "Vat Mapping"
}: VatOptionSelection): JSX.Element {
  return (
    <Autocomplete
      options={vatPercentageOptions}
      data-testmation={dataTestmation}
      value={value || null}
      onChange={(e, v) => {
        onChange(v as TaxationInterface);
      }}
      sx={{ flexGrow: 1, ...sx }}
      getOptionLabel={(option) => `${option.description}`}
      renderInput={(params) => (
        <TextField
          data-testmation="ledgerMapping"
          //   eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
          fullWidth
          variant="outlined"
          margin="dense"
          label={label}
          placeholder={placeholder}
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      )}
    />
  );
}
